import PropTypes from "prop-types";
import { useMemo } from "react";
import MobileUsers from "../../mobile/MobileUsers";

NewTicketUsers.propTypes = {
  newUsers: PropTypes.array,
  setNewUsers: PropTypes.func,
  possibleUsers: PropTypes.array
}

export default function NewTicketUsers({newUsers, setNewUsers, possibleUsers}) {

  const removeUser = (userId) => {
    setNewUsers(newUsers.filter(u => u.id !== userId))
  }

  const addNewUser = (newValue) => {
    setNewUsers(newValue);
  }

  return <MobileUsers userOptions={possibleUsers} ticketUsers={newUsers} addUser={addNewUser} removeUser={removeUser}/>
}